import { render, staticRenderFns } from "./DashboardNumbers.vue?vue&type=template&id=d72776ae&scoped=true"
import script from "./DashboardNumbers.vue?vue&type=script&lang=ts"
export * from "./DashboardNumbers.vue?vue&type=script&lang=ts"
import style0 from "./DashboardNumbers.vue?vue&type=style&index=0&id=d72776ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72776ae",
  null
  
)

export default component.exports